/**
 * Represents supported EVM (Ethereum Virtual Machine) blockchain networks
 * @enum {string}
 */
export enum EVMChain {
  /** The Ethereum mainnet network */
  ethereum = 'ethereum',
  /** The Base network, an Ethereum L2 scaling solution */
  base = 'base',
  /** External Base network instance */
  external_base = 'external-base',
}
